// extracted by mini-css-extract-plugin
export default {"desktopNav":"desktopNav__ZGU1Y","navLeft":"navLeft__NmFlO","navRight":"navRight__ODY0Y","navLogoLink":"navLogoLink__OWM0M","navItems":"navItems__MjA3N","navItem":"navItem__M2Y4Y"};